import FootballStatsCategory from "../../../stats/football-stats-category";
import FootballState from "../../../state/football-state";
import StatsRule from "../../../../common/stats-rule";

export default class RushTouchdownStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            play.historyContains(FootballState.Rush) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const rushFragment =
            play.getPreceedingFragment(fragment, [FootballState.Rush]) ||
            fragment;

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: rushFragment.rushedBy.teamId,
            playerId: rushFragment.rushedBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: rushFragment.id,
            category: FootballStatsCategory.RUSH,
            values: {
                touchdowns: 1
            }
        });
    }
}
